import { createAsyncThunk } from '@reduxjs/toolkit';
import { vendorDashboardService, type VendorDashboardData } from '@qcdoc/shared/services/repositories/vendorDashboardService.ts';
import { extractErrorMessage } from '@qcdoc/shared/shared/utils/errorMessage.ts';

export const fetchVendorDashboard = createAsyncThunk<VendorDashboardData, string | undefined, { rejectValue: string }>(
  'vendorDashboard/fetch',
  async (vendorId, { rejectWithValue }) => {
    try {
      return await vendorDashboardService.getDashboard(vendorId!);
    } catch (error) {
      return rejectWithValue(extractErrorMessage(error, 'Unable to load dashboard data.'));
    }
  },
  { condition: (vendorId) => !!vendorId },
);

